import apiCall from '../../index'

const apiService = '/api-erpunigas/api/v1/inventario/abastecimiento'
const apiService2 = '/api-erpunigas/api/v1/inventario/abastecer'
const authorization = 'Authorization'
const tipoToken = 'Bearer'

const service = {
  findAll(params) {
    const query = `?etapa=${params.etapa}&fechaIngreso=${params.fechaIngreso}&idConductor=${params.idConductor}&idFlota=${params.idFlota}&limit=${params.limit}&page=${params.page}&query=${params.query}&sortBy=${params.sortBy}&tipo=${params.tipo}`
    return new Promise((resolve, reject) => {
      apiCall
        .defaults
        .headers
        .common[authorization] = `${tipoToken} ${localStorage.getItem('accessToken')}`
      apiCall
        .get(apiService + query)
        .then(res => resolve(res.data))
        .catch(err => reject(err))
    })
  },
  findById(params) {
    const query = `/${params.codigo}`
    return new Promise((resolve, reject) => {
      apiCall
        .defaults
        .headers
        .common[authorization] = `${tipoToken} ${localStorage.getItem('accessToken')}`
      apiCall
        .get(apiService2 + query)
        .then(res => resolve(res.data))
        .catch(err => reject(err))
    })
  },
}

export default service
